import * as React from 'react'
import Img from 'components/common/Img'
import SanityBlock from 'components/common/SanityBlock'
import MailchimpSubscribe from 'react-mailchimp-subscribe'
import { Input } from 'components/form/Inputs'
import MailchimpStatus from 'components/common/MailchimpStatus'

export default function EmailSignupForm({
	_rawIntro,
	mailchimpUrl,
	logos,
	bgImage,
}) {
	return (
		<section
			id="signup"
			className="relative bg-suede-black text-center text-white"
		>
			<Img
				image={bgImage}
				className="!absolute inset-0 size-full opacity-20 grayscale"
				objectFit="cover"
				draggable={false}
			/>

			<div className="ctnr padding relative mx-auto max-w-screen-md space-y-12">
				<header className="[&_h2]:h1 text-balance">
					<SanityBlock className="space-y-3" body={_rawIntro} />
				</header>

				<MailchimpSubscribe
					url={mailchimpUrl}
					render={(props) => <SignupForm {...props} />}
				/>

				{!!logos?.length && (
					<>
						<hr className="mx-auto max-w-lg" />

						<figure className="mx-auto flex max-w-xl items-center justify-center gap-4 grayscale md:gap-8">
							{logos?.map(({ name, image }, key) => (
								<Img
									className="[&:not(:first-child)]:max-w-[60px] [&:not(:first-child)]:brightness-[1.75]"
									image={image?.original}
									alt={name}
									key={key}
								/>
							))}
						</figure>
					</>
				)}
			</div>
		</section>
	)
}

function SignupForm({ subscribe, status, message }) {
	const fname = React.useRef(null)
	const lname = React.useRef(null)
	const email = React.useRef(null)

	function submit() {
		fname.current.value &&
			lname.current.value &&
			email.current.validity.valid &&
			subscribe({
				FNAME: fname.current.value,
				LNAME: lname.current.value,
				EMAIL: email.current.value,
			})
	}

	return (
		<div className="space-y-6 [&_input]:text-ink">
			<div className="flex flex-wrap items-end gap-x-4 gap-y-3 text-left text-sm *:grow">
				<Input ref={fname} label="First Name" required />
				<Input ref={lname} label="Last Name" required />
				<Input ref={email} label="Email" type="email" required />

				<button
					className="action self-end py-[.8em] <md:mt-3 <md:w-full"
					onClick={submit}
				>
					Get started
				</button>
			</div>

			<MailchimpStatus
				status={status}
				message={message}
				redirectUrl="/contact/thank-you"
			/>
		</div>
	)
}
